import { Router } from '@angular/router';
import { UsersService } from '../users/users.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../users/users.service";
export class RequirePasswordUpdateGuard {
    constructor(router, usersService) {
        this.router = router;
        this.usersService = usersService;
    }
    canLoad(route) {
        return new Promise(resolve => {
            this.usersService
                .requirePasswordUpdate()
                .then(user => {
                resolve(true);
            })
                .catch(() => {
                this.router.navigate(['/profile/change-password'], { queryParams: { returnUrl: window.location.pathname } });
                resolve(false);
            });
        });
    }
    canActivate(route, state) {
        return new Promise(resolve => {
            this.usersService
                .requirePasswordUpdate()
                .then(user => {
                resolve(true);
            })
                .catch(() => {
                this.router.navigate(['/profile/change-password'], { queryParams: { returnUrl: state.url } });
                resolve(false);
            });
        });
    }
}
RequirePasswordUpdateGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RequirePasswordUpdateGuard_Factory() { return new RequirePasswordUpdateGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.UsersService)); }, token: RequirePasswordUpdateGuard, providedIn: "root" });
